module.exports = __webpack_public_path__ + "img/cope-logo.8bfe5388.svg";